define('AwaLabs.StagingNoIndex', [
    'SC.Configuration',
    'jQuery'
], function AwaLabsStagingNoIndex(
    Configuration,
    jQuery
) {
    'use strict';

    return {
        stagingDomain: '.awalabs.site',
        isStagingDomain: function isStagingDomain() {
            return (location.hostname.indexOf(this.stagingDomain, location.hostname.length - this.stagingDomain.length) !== -1);
        },
        mountToApp: function mountToApp() {
            var $head;
            var $meta;
            if (this.isStagingDomain()) {
                $head = jQuery('head');
                $meta = $head.find('meta[name="robots"]');
                if ($meta.length > 0) {
                    $meta.attr('content', 'noindex, nofollow');
                } else {
                    $meta = jQuery('<meta name="robots" content="noindex, nofollow">');
                    $head.append($meta);
                }
            }
        }
    };
});
